import type { CSSProperties } from 'react';

/* IsoSofts marka işareti — favicon.svg ve intro splash ile BİREBİR aynı:
   FontAwesome "circle-nodes" üçgeni (beyaz), mavi→indigo degrade yuvarlatılmış
   kare üzerinde. Suite genelinde tek kaynak; harf placeholder'ları (I/A/D/E)
   bunun yerine kullanılmamalı. Inline SVG — FontAwesome bağımlılığı yok. */
const MARK_PATH =
  'M482.4 221.9C517.7 213.6 544 181.9 544 144C544 99.8 508.2 64 464 64C420.6 64 385.3 98.5 384 141.5L200.2 215.1C185.7 200.8 165.9 192 144 192C99.8 192 64 227.8 64 272C64 316.2 99.8 352 144 352C156.2 352 167.8 349.3 178.1 344.4L323.7 471.8C321.3 479.4 320 487.6 320 496C320 540.2 355.8 576 400 576C444.2 576 480 540.2 480 496C480 468.3 466 443.9 444.6 429.6L482.4 221.9zM220.3 296.2C222.5 289.3 223.8 282 224 274.5L407.8 201C411.4 204.5 415.2 207.7 419.4 210.5L381.6 418.1C376.1 419.4 370.8 421.2 365.8 423.6L220.3 296.2z';

interface BrandMarkProps {
  size?: number;
  radius?: number;
  className?: string;
  style?: CSSProperties;
}

/* size = kutunun kenarı (px). Köşe yarıçapı ve ikon boyu intro'daki 72/20/32
   oranlarından türetilir, böylece her ölçekte aynı görünür. */
export default function BrandMark({ size = 32, radius, className = '', style = {} }: BrandMarkProps) {
  const glyph = Math.round((size * 32) / 72);
  return (
    <div
      className={className}
      style={{
        width: size,
        height: size,
        borderRadius: radius ?? Math.round((size * 20) / 72),
        background: 'linear-gradient(135deg,#3b82f6,#6366f1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        ...style,
      }}
    >
      <svg width={glyph} height={glyph} viewBox="0 0 640 640" fill="#fff" aria-hidden="true" focusable="false">
        <path d={MARK_PATH} />
      </svg>
    </div>
  );
}

/* Sadece glif (kutusuz) — zaten degrade kutusu olan yerler için (intro splash). */
export function BrandGlyph({ size = 32, color = '#fff' }: { size?: number; color?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 640 640" fill={color} aria-hidden="true" focusable="false">
      <path d={MARK_PATH} />
    </svg>
  );
}
